import { CommentAccountOutlineIcon } from './CommentAccountOutlineIcon';

/**
 * author: Austin Andrews
 * id 18A9FFE4-B768-4A8F-BD55-778C8E8C41FC
 * name comment-account-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-account-outline.svg
 * tags
 * - Account / User 
 */
export const CommentPersonOutlineIcon = CommentAccountOutlineIcon;
export default CommentPersonOutlineIcon